import {Instance, types} from 'mobx-state-tree';
import {EntityBaseInfo} from 'core/models';

const ReactionInfo = types.compose(EntityBaseInfo, types.model('ReactionInfo', {}));

export type TReactionInfoModel = Instance<typeof ReactionInfo>;

export {ReactionInfo};
